/* Senswell tag-based sale countdown.
   Self-scanning so it reattaches after Horizon re-renders prices on variant change.
   Reads each .tag-sale__countdown[data-countdown-end] (UNIX epoch seconds, computed
   server-side in Liquid from the akhir: tag) and ticks once per second. */
(function () {
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function format(totalSeconds) {
    var d = Math.floor(totalSeconds / 86400);
    var h = Math.floor((totalSeconds % 86400) / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    var hms = pad(h) + ':' + pad(m) + ':' + pad(s);
    return d > 0 ? d + ' hari ' + hms : hms;
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    var nodes = document.querySelectorAll('.tag-sale__countdown[data-countdown-end]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var end = parseInt(el.getAttribute('data-countdown-end'), 10);
      if (!end) continue;
      var remain = end - now;
      var prefix = el.getAttribute('data-countdown-prefix') || '';
      if (remain <= 0) {
        el.textContent = 'Promo telah berakhir';
        el.classList.add('is-ended');
        continue;
      }
      el.classList.remove('is-ended');
      el.textContent = (prefix ? prefix + ' ' : '') + format(remain);
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
